export const statusLabel = {
  new: "New",
  processing: "Processing",
  entered: "Entered",
  awaiting_law_firm_info: "Awaiting Law Firm Info",
  vetted: "Vetted",
  closed_not_sent: "Closed - Not Sent",
  needs_further_review: "Needs Further Review",
};
